<template>
  <div class="pa-heart-plus-button" @click.prevent="handleClick">
    <font-awesome-icon :icon="prefixIcon" />
    <font-awesome-icon icon="heart" />
  </div>
</template>

<script>
export default {
  props: {
    prefixIcon : {
      default: 'plus' // minus
    }
  },

  methods : {
    handleClick(){
      this.$emit('click');
    }
  }
}
</script>

<style lang="scss">
.pa-heart-plus-button{
  background-color: #B39571;
  background-color: #BB9D79;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  color:#7D593C;
  padding:0 5px;
  user-select: none;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;

  svg{
    margin-right: .2rem;

    &:first-child{
      margin-top:-.5px;
      font-size:14px;
    }

    &:last-child{
      margin-right: 0;
    }
  }
}
</style>